export const getReplayURL = async (
  samsId: string,
  binaryHighlights: string,
): Promise<string> => {
  const requestOptions: RequestInit = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      samsId,
      binaryHighlights,
    }),
  };

  return fetch(
    `${import.meta.env.VITE_BACKEND_BASE_URL}/replay-url`,
    requestOptions,
  ).then(async (response) => {
    const body = await response.json();
    return body.path;
  });
};
